module.exports = __webpack_public_path__ + "img/marketing_2.f07a3a5d.jpg";